import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";

const CardStatus = ({ children, className = "", faIcon = faFlag, statusType = "new" }) => (
  <div className={`card__status card__status--${statusType} ${className}`}>
    <FontAwesomeIcon icon={faIcon} />
    <span className="card__status__text">{children}</span>
  </div>
);

CardStatus.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default CardStatus;
